/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import variables from './variables.module.scss'
const fonts = {
    caslon: variables?.bigCaslonRegular,
    body: variables?.inter,
    heading: variables?.cormorantRegular,
    inter: variables?.inter,
    ksSansSerif: variables?.ksSansSerif,
    cormorant: variables?.cormorantRegular,
    'brandon-grotesque': variables?.brandonGrotesque
}

export default fonts
